import React, { useEffect} from "react";
import { useDispatch } from "react-redux";
import "./styles.scss";
import { useNavigate } from "react-router-dom";

import WrongIcon from "../../assets/images/wrong.png";
import { Card, CardBody } from "react-bootstrap";
import {
  activityStart,
  activityEnd,
} from "../../redux/slices/trackActivitySlice";
import usePageTracking from "../../hooks/usePageTracking";

const CancelPage = () => {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const isValid = new URLSearchParams(window.location.search).get("isValid");
  console.log(isValid, "no");

  useEffect(() => {
    dispatch(activityStart({ page_name: "PAYMENT_CANCEL", platform: "web" }));
  }, [dispatch]);

  useEffect(() => {
    return () => {
      dispatch(activityEnd({ page_name: "PAYMENT_CANCEL" }));
    };
  }, [dispatch]);

  usePageTracking("PAYMENT_CANCEL");

  useEffect(() => {
    if (!isValid) {
      navigate("/", { replace: true });
    }
  }, [isValid, navigate]);
  return (
    <div className="payments-cancel-wrapper">
      <Card className="mb-0 pb-0">
        <CardBody>
          {/* Main Cancel Section */}
          <h2 className="title">Payment Not Completed</h2>

          {/* <p className="welcome">
          Hello, <span className="name">User</span>
        </p> */}

          <p className="sub-text">
            Your payment process was cancelled. <br />
            No charges have been applied to your account.
          </p>

          <div className="cancel-icon">
            <span>
              <img src={WrongIcon} alt="Verified" />
            </span>
          </div>

          <a href="/dashboard" className="dashboard-link">
            Go to dashboard
          </a>
        </CardBody>
      </Card>
    </div>
  );
};

export default CancelPage;
